/** Plan asignado automáticamente al registrar un anfitrión por primera vez (sin ?plan= en la URL). */
export const DEFAULT_REGISTRATION_PLAN_ID = 16

/** Plan asignado automáticamente al registrar un anfitrión por primera vez (sin ?plan= en la URL). */
export const DEFAULT_LICENSES_NUMBER = 1
